module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/video-c-4-ce13a23641913d0ba196fb1fd3f1323f.jpg";